// Shared reminders for tools that parse provider returns or exports:
// - ReviewCaveat: always check the original records; these tools are review aids.
// - GeneratedMark / GeneratedLegend: a ✱ on anything the tool worked out itself
//   (rankings, inferences, predictions), as opposed to data copied from the return.

export const GENERATED = 'Generated by LE Tech Tools. Not part of the original legal return.';

const AMBER = { light: { bg: '#fffbeb', border: '#fde68a', text: '#92400e' }, dark: { bg: 'rgba(251,191,36,.08)', border: 'rgba(251,191,36,.35)', text: '#fbbf24' } };

// `what` names the originals, e.g. "the actual returns from Meta".
export function ReviewCaveat({ what = 'the actual returns from the provider', dark = false, style }) {
  const c = dark ? AMBER.dark : AMBER.light;
  return (
    <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10, padding: '12px 16px', background: c.bg, border: `1px solid ${c.border}`, borderRadius: 10, fontSize: 13.5, color: c.text, lineHeight: 1.55, ...style }}>
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0, marginTop: 2 }} aria-hidden>
        <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" /><line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" />
      </svg>
      <span>
        <strong>Always refer to {what}.</strong> This tool only helps you review the records. It does not replace the original
        data, and anything you rely on (in a report, affidavit or court) should be checked against the original files.
      </span>
    </div>
  );
}

export function GeneratedMark({ dark = false }) {
  return <span title={GENERATED} style={{ color: dark ? AMBER.dark.text : '#b45309', marginLeft: 4 }}>✱</span>;
}

export function GeneratedLegend({ dark = false, children, style }) {
  return (
    <div style={{ fontSize: 12, color: dark ? '#94a3b8' : '#64748b', lineHeight: 1.5, ...style }}>
      <span style={{ color: dark ? AMBER.dark.text : '#b45309' }}>✱</span> {children || GENERATED}
    </div>
  );
}
